module.exports = __webpack_public_path__ + "img/activeicon-network.1d93e69b.svg";